import TooltipCustom from "components/Common/TooltipCustom";
import React from "react";
import { useTranslation } from "react-i18next";
import { Card } from "reactstrap";
import IconFavorite from "./Icons/IconFavorite";
import IconDownload from "./Icons/IconDownload";
import IconDelete from "./Icons/IconDelete";
import IconEdit from "./Icons/IconEdit";
import IconPrivate from "./Icons/IconPrivate";
import IconPublic from "./Icons/IconPublic";

export interface Props {
    info?: any,
    handleActionDownload: (item: any) => void,
    handleActionEdit: (item: any) => void,
    handleConfirmDelete: (item: any) => void,
    handleActionFavorite: (item: any) => void
}

const ImageBox = ({
    info = null,
    handleActionDownload,
    handleActionEdit,
    handleConfirmDelete,
    handleActionFavorite
}: Props) => {

    const { t } = useTranslation();
    const onClickActionDownload = () => {
        handleActionDownload && handleActionDownload(info);
    };

    const onClickActionEdit = () => {
        handleActionEdit && handleActionEdit(info);
    };

    const onClickActionFavorite = () => {
        handleActionFavorite && handleActionFavorite(info);
    };

    const onClickConfirmDelete = () => {
        handleConfirmDelete && handleConfirmDelete(info);
    };

    const splitTagLong = (_tag: string = '') => {
        if (_tag?.length >= 15) {
            return (String(_tag || '')?.slice(0, 3) + "..." + String(_tag || '')?.slice(-1))
        }
        return _tag;
    };

    return (
        <React.Fragment>
            <Card className="gallery-box mb-3" style={{ padding: '8px 10px' }}>
                <div className="gallery-container d-flex justify-content-center align-items-center " style={{ height: '100%', textAlign: 'center', backgroundColor: '#eaeaea', borderRadius: '3px' }} >
                    <img className="gallery-img img-fluid mx-auto"
                        style={{ objectPosition: 'center' }}
                        src={info?.thumbnail_url || ''}
                        alt={(info?.tags)?.join(', ') || ''}
                    // loading="lazy"
                    />
                    {/* onClick={(e: any) => onClickActionDownload()} */}
                    <div className="gallery-overlay">

                    </div>
                    <div style={{ position: 'absolute', top: '10px', right: '10px' }} className="d-flex justify-content-center align-items-center gap-2">
                        <TooltipCustom
                            title={!!info?.is_my ? t('My Image') : t('Public Image')}
                            className="d-inline-block vertical-align-middle"
                            style={{ transform: 'translateY(1px)' }}
                        >
                            <button type="button" className="btn btn-sm text-center align-center"
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    padding: '0',
                                    cursor: 'default'
                                }}
                            >{!!info?.is_my ?
                                <div style={{ transform: 'translate(0px, -3.8px)' }}>
                                    <IconPrivate />
                                </div> : <div style={{ transform: 'translate(0px, -3.8px)' }}>
                                    <IconPublic width={29} height={29} />
                                </div>}
                            </button>
                        </TooltipCustom>
                    </div>
                </div>
                <div className="box-content">
                    <div className="d-flex align-items-center">
                        <div className="badge-wrapper d-flex flex-grow-1 gap-1 text-muted" style={{ paddingTop: '2px' }}>
                            {(info?.tags || [])?.map((tag: string) => <span className="badge rounded-1 border border-secondary text-secondary fs-12 fw-normal py-1 px-2" key={tag}>#{splitTagLong(tag || '')}</span>)}
                        </div>
                        <div className="flex-shrink-0">
                            <div className="d-flex gap-2">
                                <TooltipCustom
                                    title={t('Favorite')}
                                    className="d-inline-block vertical-align-middle"
                                >
                                    <button type="button" className="btn btn-sm fs-13 btn-link text-body text-decoration-none px-0"
                                        onClick={(e: any) => { e.stopPropagation(); onClickActionFavorite() }}
                                        style={{ transform: 'translateY(-1px)' }}
                                    >
                                        <IconFavorite width={22} height={22} is_active={info?.is_favorite} />
                                        {/* {info?.total_favorites || 0} */}
                                    </button>
                                </TooltipCustom>
                                {!!info?.is_my && <TooltipCustom
                                    title={t('Edit')}
                                    className="d-inline-block vertical-align-middle"

                                >
                                    <button type="button" className="btn btn-sm fs-13 btn-link text-body text-decoration-none px-0"
                                        onClick={(e: any) => { e.stopPropagation(); onClickActionEdit() }}
                                    >
                                        <IconEdit width={19} height={19} />
                                    </button>
                                </TooltipCustom>}
                                <TooltipCustom
                                    title={t('Download')}
                                    className="d-inline-block vertical-align-middle"

                                >
                                    <button type="button" className="btn btn-sm fs-13 btn-link text-body text-decoration-none px-0"
                                        onClick={(e: any) => { e.stopPropagation(); onClickActionDownload() }}
                                    >
                                        <IconDownload width={19} height={19} />
                                        {/* {info?.total_downloads || 0} */}
                                    </button>
                                </TooltipCustom>
                                {!!info?.is_my && <TooltipCustom
                                    title={t('Delete')}
                                    className="d-inline-block vertical-align-middle"

                                >
                                    <button type="button" className="btn btn-sm fs-13 btn-link text-body text-decoration-none px-0"
                                        onClick={(e: any) => { e.stopPropagation(); onClickConfirmDelete() }}
                                    >
                                        <IconDelete width={20} height={20} />
                                    </button>
                                </TooltipCustom>}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment >
    );
};

export default React.memo(ImageBox);